import { Reducer, useEffect, useReducer } from 'react';
import styles from './selectStyle.scss';
import Icon from 'components/Shared/Icon/index';
import { NO_ELEMENT } from 'utils';
import { Option, Select, SelectClassNames } from 'components/Shared/Select';
import cn from 'classnames';
import { WrappedFieldInputProps } from 'redux-form';

interface OwnState {
  selectedValue: string;
}

const initialState: OwnState = {
  selectedValue: ''
};

interface OwnAction {
  type: 'select';
  value: string;
}

const ownReducer: Reducer<OwnState, OwnAction> = (state, action) => {
  switch (action.type) {
    case 'select':
      return {
        ...state,
        selectedValue: action.value
      };
    default:
      return state;
  }
};

export interface OptionProps {
  label: string;
  value: string;
  selected: boolean;
}

export interface SelectProps extends WrappedFieldInputProps {
  invalid?: boolean;
  valid?: boolean;
  options?: OptionProps[];
}

export const DropDownSelect = ({ options, onChange, invalid, valid, value }: SelectProps) => {
  const [state, dispatch] = useReducer(ownReducer, initialState);

  const selectClassNames: SelectClassNames = {
    input: styles.selectInput
  };

  useEffect(() => {
    if (options === undefined || options.length === 0) {
      return;
    }
    dispatch({ type: 'select', value: value });
    onChange && onChange(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  if (!options || options.length === 0) {
    return NO_ELEMENT;
  }

  const select = (value: React.ReactText) => {
    onChange && onChange(value.toString());
    dispatch({ type: 'select', value: value.toString() });
  };

  return (
    <div
      className={cn(styles.select, {
        [styles.invalid]: invalid,
        [styles.valid]: valid
      })}
    >
      <Select
        appearance="secondary"
        onChange={val => {
          select(val);
        }}
        selectedValue={state.selectedValue}
        scrollable
        classNames={selectClassNames}
        valid={valid}
        invalid={invalid}
      >
        {options.map(value => (
          <Option key={value.value} {...value} />
        ))}
      </Select>
      {invalid && (
        <Icon icon="icon-warning" inline className={cn(styles.inputIcon, styles.invalid)} />
      )}
      {valid && (
        <Icon
          icon="icon-check"
          inline
          size="small"
          className={cn(styles.inputIcon, styles.valid)}
        />
      )}
    </div>
  );
};
